import { SoilType } from '../models/soil-type.models';

export const sortByName = (a: SoilType, b: SoilType) => a.name.localeCompare(b.name);
